const axios = require('axios');

const apiClient = axios.create({
     baseURL: process.env.VUE_APP_API_BASE_URL + '/api'  || 'https://merch70000tons.com/api', // For Vue CLI
});

export async function getNowServing() {
    const response = await apiClient.get('/getNowServing');
    return response.data;
}

export async function setNowServing(from, to) {
    let data = { 'from': from, 'to': to };
    const response = await apiClient.post('/setNowServing', { data });
    return response.data;
}

export async function setStatus(status) {
    let data = { 'status': status };
    const response = await apiClient.post('/setStatus', { data });
    return response.data;
}
